/*
 * @Author: zhaozhuo
 * @Date: 2022-02-18 11:54:58
 * @LastEditors: zhengshuhua
 * @LastEditTime: 2022-09-19 11:16:04
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\store\center\state.js
 */
import * as STATETYPES from '../stateTypes'
const state = {
	[STATETYPES.CENTERNAME]: '' // 中心名称
}
export default state